import React from "react"
import './comb.css'

const Honeycomb = () => (
<div class="honeycomb">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
)

export default Honeycomb
